import { observable, action, makeObservable } from 'mobx';
import { ReceiptInfoFormState } from './ReceiptInfoFormState';
import { UserInfoApis } from '../../../../apis/user_info';
import { GlobalStatesV3 } from '../../../../../commonv3/states/GlobalStatesV3';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';
import { CurrentProfile } from '../../../../types/user_info';
import { V3Routes } from '../../../../routes';

export class ReceiptInfoState {
  currentProfile: RemoteResourceV3<CurrentProfile> = RemoteResourceV3.loading();
  formState: ReceiptInfoFormState = new ReceiptInfoFormState();
  submitting = false;

  constructor() {
    makeObservable(this, {
      currentProfile: observable,
      formState: observable,
      submitting: observable,
      reloadProfileUrl: action.bound,
      submit: action.bound,
    });
  }

  init() {
    this.reloadProfileUrl();
  }

  async reloadProfileUrl() {
    const currentProfile = await updateRemoteResourceV3(
      this.currentProfile,
      (v) => (this.currentProfile = v),
      () => UserInfoApis.findProfile()
    );
    this.formState.fields.name.setValue(currentProfile.job_company);
    this.formState.fields.appelation.setValue('御中');
  }

  async submit(code: string) {
    this.submitting = true;
    GlobalStatesV3.routing.push(
      V3Routes.receipt(
        code,
        this.formState.getValue('name'),
        this.formState.getValue('purpose'),
        this.formState.getValue('appelation')
      )
    );
  }
}
